export const locale = {
    lang: 'en',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': 'Two-step authentication',
          'SUBTITULO': 'To provide greater security when entering the platform, it is necessary that you perform two-step authentication as indicated below',
          'BOTONES': {
            'SIGUIENTE': 'Next',
            'ANTERIOR': 'Previous'
          },
          'PASOS': {
            '1': {
              'TITULO': 'Step 1',
              'INSTRUCCION': 'Scan the QR code with the Google Authenticator mobile app and click the next button',
              'REGISTRADO': 'It was detected that your email is already registered in the Google Authenticator application, it is not necessary to scan the QR code again, continue to the next step'
            },
            '2': {
              'TITULO': 'Step 2',
              'INSTRUCCION': 'Enter the key provided by Google Authenticator and click next',
              'INPUT': 'Key obtained',
              'INFOPREVIA': {
                'INFO_1': 'It was detected that you have already accessed the platform from this computer. No need to scan the QR code again',
                'INFO_2': 'Just enter the password provided by Google Authenticator for your account and click next',
                'INFO_3': 'If you want to scan the QR code again, click the Previous button',
                'INFO_4': 'Warning: by doing this, you will have to link your account to Google Authenticator again',
              }
            },
            '3': {
              'TITULO': 'Result',
              'INSTRUCCION': 'Enter the key obtained from the QR code in the previous step and click next button',
              'VALIDANDO': 'Validating the entered key, wait a moment',
              'MAL': 'The key is incorrect or has expired, please re-enter the key and try again',
              'BIEN': 'You have successfully completed the authentication, then you will enter the platform'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'Please enter your email address, we will send you a link to change your password',
          'BTN':'Send Email',
          'PLACERHOLDER':'Email address',
          'ERROR':'We have no found your email. Please try a different email',
          'TRUE':'The email has being send, please check your inbox instead or spam folder'
        },
        'RESET':{
          'LABEL01':'Please... enter your new password for the user:   ',
          'LABEL02':'Password',
          'LABEL03':'Retype password',
          'BTN':'Change password',
          'ERROR':'Error, the token has not found',
          'NOPASSWORDMATCH':'The password does not match',
          'CARACTERES':'Must be at least 3 characters',
          'SUCCESSCHANGE':'Your password has been changed correctly'
        },
        'LANDING': {
          'MENSAJE': 'Welcome',
          'NAVEG': ''
          //'NAVEG': 'The use of <a class="linkChrome" href="https://www.google.com/intl/es-419/chrome/" target="blank">Google Chrome</a> browser is recommended'
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': 'Important announcement.',
            'TEXTO': `Dear user:<br><br>
            You are informed that, in order to provide a better service, an update of the Cultural GO platform will be carried out to optimize its operation.<br><br>
            The update will take place on <strong>Friday, July 23, from 11:59 p.m. until 11:59 p.m. on Saturday, July 24</strong>. During that period the platform will remain inactive. However, the current surveys will remain active.<br><br>
            `
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'Password recovery',
          'LOGIN':'Login',
          'TITULO': 'LOGIN INTO YOUR ACCOUNT',
          'INPUT':{
            'EMAIL': 'Email',
            'PASSWORD': 'Password',
            'LANGSEL': 'Choose a language'
          },
          'VAL': {
            'NOTEMAIL': 'Email is required ',
            'INVEMAIL': 'Please enter a valid email address ',
            'CARACT_EMA': ' Field does not allow the following characters /&¿+#$%([=])*?"<>:\'',
            // 'PASS': ' Password is required ',
            'PASS': 'Invalid password',
          },
          'SIGNIN': 'GO!',
          'CAMBIALOGO': 'Click here to change your company logo',
          'CARGAOK': 'Your company logo was loaded correctly',
          'CARGANULL': 'There was an error loading your company logo',
          'CARGAERROR': 'The format of the selected file is not correct. Only formats are accepted: jpg, png, gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'PASSWORD': 'Password:',
            'LANGSEL': 'Choose a language:',
            'LOGIN': 'Login',
          },

      },
      'INTRO-LOGIN':{
        'TITULO':'INSTRUCTIONS',
        'TEXT1':'Great Place to Work® Institute. welcomes you to answer your work climate survey 100% confidentially',
        'TEXT2':'Confidentiality',
        'TEXT3':'At the Institute:',
        'TEXT4':'we administer, process, statistically analyze responses by organization and area.',
        'TEXT5':'We generate global results that indicate the improvement actions in the organizations climate.',
        'TEXT6':'you wont know the individual responses',
        'TEXT7':'Individual responses are strictly confidential,',
        'TEXT8':'Denuncias y Sugerencias',
         'TEXT9':' Está estrictamente prohibido que:',
         'TEXT10':'se te influencie, penalice o impida de cualquier forma responder libremente la encuesta.',
         'TEXT11':'Ponemos a tu disposición el siguiente correo para hacer denuncias o sugerencias:',
         'TEXT12':'mx_transparencia@greatplacetowork.com',
         'TEXT13':'Instrucciones:',
         'TEXT14':'1. Ingresa tu ',
         'TEXT15':'número de empleado + año de nacimiento.',
         'TEXT16':'2. No dejes espacios en blanco.',
         'TEXT17':'3. Da clic en Iniciar.',
         'TEXT18':'¡Ayúdanos a contestar la encuesta de Great Place to Work® Institute!',
      }

    },
    'LOADING':{
      'TEXT_WELCOM':'Welcome to CulturalGo',
     'TEXT_CHANGE':'Loading information...',
    }
    }
};
